import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-place-destination-maye-preview',
  templateUrl: './place-destination-maye-preview.component.html',
  styleUrls: ['./place-destination-maye-preview.component.scss']
})
export class PlaceDestinationMayePreviewComponent {
  @Input() report: any = null;
  @Input() loading = false;

  trackByPlace = (_: number, item: any) => item.placeId;
  trackByDestination = (_: number, item: any) => item.destinationId;

  nz(v: number | null | undefined): number {
    return v ?? 0;
  }
}
